module.exports = __webpack_public_path__ + "img/F9E6C7_FCF7DF_EDD3AA_F1D4B4-256px.3b2e438b.png";